/*
  Wood Store: live countdown for the promotion discount line in the cart.

  Registered as a custom element on purpose. cart.js replaces the whole inner
  HTML of the cart drawer and the cart page's subtotal block on every quantity
  change, which kills any timer started by an inline script. A custom element
  runs connectedCallback again on each fresh instance instead, so the clock
  survives a re-render.

  This file is loaded from a plain <script src> tag that sits OUTSIDE the cart's
  conditional markup, because scripts injected via innerHTML never execute. By
  the time a re-rendered <ws-countdown> lands in the DOM the definition is
  already registered, so the browser upgrades the new element immediately.

  Also used by the big sale clock (snippets/ws-sale-clock) and the header strip
  (sections/ws-sale-countdown). Any wrapper marked data-ws-countdown-line is
  removed whole at zero. With data-format="tiles" the element keeps its markup
  and only the [data-u] number spans are updated.
*/
(function () {
  if (window.customElements && customElements.get('ws-countdown')) return;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  class WsCountdown extends HTMLElement {
    connectedCallback() {
      var endsAt = parseInt(this.getAttribute('ends-at'), 10);

      // No usable deadline: leave the Liquid-rendered fallback text in place
      // rather than blanking the line out.
      if (!endsAt) return;

      this.endsAtMs = endsAt * 1000;
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      var left = Math.floor((this.endsAtMs - Date.now()) / 1000);

      // Past the deadline the discount is gone from the cart anyway, so take
      // the whole line out instead of showing a frozen zero.
      if (left <= 0) {
        clearInterval(this.timer);
        var line = this.closest('[data-ws-countdown-line]') || this.closest('.ws-promo-countdown');
        (line || this).remove();
        return;
      }

      var days = Math.floor(left / 86400);
      var hours = Math.floor((left % 86400) / 3600);
      var mins = Math.floor((left % 3600) / 60);
      var secs = left % 60;

      if (this.dataset.format === 'tiles') {
        var parts = { d: pad(days), h: pad(hours), m: pad(mins), s: pad(secs) };
        var nums = this.querySelectorAll('[data-u]');
        for (var i = 0; i < nums.length; i++) {
          nums[i].textContent = parts[nums[i].getAttribute('data-u')];
        }
        return;
      }

      // Clock only. The "... ends in" label is rendered by Liquid as a sibling,
      // so it stays translatable and is not rewritten every second.
      this.textContent =
        days + 'd ' + pad(hours) + 'h ' + pad(mins) + 'm ' + pad(secs) + 's';
    }
  }

  customElements.define('ws-countdown', WsCountdown);
})();
